import axios from 'axios';


export function getProductsByCategoryId(categoryId) {
  return axios.get(process.env.API_URL+'/category/products?categoryId='+categoryId)
  .then(function(response) {
    return response['data']['item'];
  });
}

export function getProductById(productId) {
  return axios.get(process.env.API_URL+'/product?id='+productId)
  .then(function(response) {
    return response['data']['item'];
  });
}


// WEBPACK FOOTER //
// ./src/api/products.js